import React from 'react';
import { motion } from 'framer-motion';

export const ProgressBar = ({ current, total }) => {
  const pct = Math.min(100, Math.max(0, (current / total) * 100));
  return (
    <div className="w-full" data-testid="quiz-progress-wrap">
      <div className="flex items-center justify-between mb-3">
        <span className="text-xs uppercase tracking-[0.22em] font-semibold text-brand-muted font-heading" data-testid="quiz-progress-label">
          Question {current} of {total}
        </span>
        <span className="text-xs uppercase tracking-[0.22em] font-semibold text-brand-forest font-heading">
          {Math.round(pct)}%
        </span>
      </div>
      <div className="h-1.5 w-full bg-brand-progress rounded-full overflow-hidden">
        <motion.div
          className="h-full bg-brand-forest rounded-full"
          initial={{ width: 0 }}
          animate={{ width: `${pct}%` }}
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
          data-testid="quiz-progress-fill"
        />
      </div>
    </div>
  );
};
